/** Hold-to-move mapping for the admin sim HUD. Codes match `stepMove` / Q-E turn / eye. */

export const HOLD_CODES = new Set([
  "KeyW",
  "KeyA",
  "KeyS",
  "KeyD",
  "KeyQ",
  "KeyE",
  "EyeUp",
  "EyeDown",
])

export function holdCodeFromTarget(target) {
  const el = target && typeof target.closest === "function" ? target.closest("[data-ar-sim-hold]") : null
  const code = el && el.dataset ? el.dataset.arSimHold : null
  return HOLD_CODES.has(code) ? code : null
}

/** +1 along look (nearer when facing the pin), −1 opposite. */
export function dollySignFromTarget(target) {
  const el = target && typeof target.closest === "function" ? target.closest("[data-ar-sim-dolly]") : null
  const n = Number(el && el.dataset ? el.dataset.arSimDolly : NaN)
  return n === 1 || n === -1 ? n : 0
}

export function dollyStepM(reach, dt) {
  const gait = reach > 80 ? Math.max(1, reach / 40) : 1
  return 12 * dt * gait
}
